<div class="form-group mb-0">
  <input
    #propertyName="ngModel"
    id="date-input-{{ name }}"
    class="form-control"
    type="text"
    [name]="name"
    [(ngModel)]="inputString"
    [disabled]="isDisabled"
    placeholder="Enter a date..."
    autocomplete="off"
    (ngModelChange)="onInputChange($event)"
    mask="M0/d0/0000"
    [outputTransformFn]="dateParser"
    obscure
    [enableObscurity]="useObscurity"
  />
  <div validationErrors [for]="propertyName.control" [errorEmitter]="errorEmitter"></div>
  <div class="form-text" [ngClass]="formTextClass">{{ formText }}</div>
</div>
